export default __webpack_public_path__ + "static/media/casaduana_LogoFooter.f29f0c28.svg";